import ActionResultDetails from "@/components/application/model/ActionResultDetails";
import {EventBus} from "@/lib/event-bus";
import {EVENTBUS_TOPICS} from "@/lib/constants";
import {i18n} from "@/main";

export default class UserActionResultSender {
  public static showSuccessFeedback(messageCode: string) {
    if (!messageCode) {
      messageCode = 'global.somethingWentWrong';
    }

    const actionResult: ActionResultDetails = {isSuccess: true, message: i18n.tc(messageCode)};
    EventBus.$emit(EVENTBUS_TOPICS.USER_ACTION_FEEDBACK, actionResult);
  }

  public static showErrorFeedback(messageCode: string) {
    if (!messageCode) {
      messageCode = 'global.somethingWentWrong';
    }

    const actionResult: ActionResultDetails = {isSuccess: false, message: i18n.tc(messageCode)};
    EventBus.$emit(EVENTBUS_TOPICS.USER_ACTION_FEEDBACK, actionResult);
  }
}
